import { Divider, Typography } from '@mui/material';
import { InfoBlockWrapper, InfoItemWrapper, StyledSubTitle } from './InfoBlock.styles';
import { getObjectValuesAsString, isObject } from '../../utils/PreparedObjects';

interface IInfoBlock {
  infoList?: Record<string, string | Record<string, string>>;
  additionalInfo?: Record<string, string>;
}

interface IInfoItem {
  title: string;
  subTitle?: string;
}

const InfoItem = ({ title, subTitle }: IInfoItem) => {
  return (
    <InfoItemWrapper>
      <Typography variant="body1" fontWeight={500}>
        {title.toUpperCase()}
      </Typography>
      <StyledSubTitle variant="body1">{subTitle?.toString()}</StyledSubTitle>
    </InfoItemWrapper>
  );
};

export const InfoBlock = ({ infoList, additionalInfo }: IInfoBlock) => {
  return (
    <InfoBlockWrapper data-testid="info-block">
      {infoList &&
        Object.entries(infoList).map((item, index) => (
          <InfoItem
            key={index}
            title={item[0]}
            subTitle={
              (isObject(item[1]) ? getObjectValuesAsString(item[1]) : item[1]?.toString()) || '-'
            }
          />
        ))}
      {additionalInfo && (
        <>
          <Divider />
          {Object.entries(additionalInfo).map((item, index) => (
            <InfoItem key={index} title={item[0]} subTitle={item[1]} />
          ))}
        </>
      )}
    </InfoBlockWrapper>
  );
};
